import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/about/Banner";
import Services from "../components/about/Services";
import Aim from "../components/about/Aim";
import Stats from "../components/home/Stats";
import Testimonials from "../components/home/Testimonials";
import Cta from "../components/cta/cta";

// import Team from "../components/about/Team";

const About = () => {
  return (
    <>
      <Layout>
        <Banner />
        <Services />
        <Aim />
        {/* <Stats /> */}
        {/* <Team /> */}
        
        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </Layout>
    </>
  );
};

export default About;